import React, { useEffect, useState, useContext } from "react"
import { Link } from "react-router-dom";
import Slidewithindicator from "./slidewithindicator"
import ReactBSAlert from "react-bootstrap-sweetalert";
import {ViolationsContext} from "components/Common/PageDataContext";
import jsPDF from 'jspdf';
import img2 from "../../assets/images/Ador_logo_cropped.png"
import Select from "react-select";
import { apiEndpoint } from "helpers/url_helper";


//import { ActiveImageContext } from './ViolationImageContext';


import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  ModalFooter,
  UncontrolledTooltip,

} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { func, string } from "prop-types";
import { eventChannel } from "redux-saga";
import { result, some } from "lodash";

import jwt from "jsonwebtoken";

const EditViolationModalComponent = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [ANPRVal, setANPR] = useState();
  const [imgData, setImageData] = useState();
  const [alertmsg, setAlert] = useState();
  const { violations, setViolations } = useContext(ViolationsContext);
  const [violationImageIndex, setViolationImageIndex] = useState(0);
  var violationImage = '';
  const [showGenerateChallanButton, setshowGenerateChallanButton] = React.useState(false);
  const[ViolationRegNo, setViolationRegNo] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modal_small, setmodal_small] = useState(false);
  const [SelectedChallanType, setSelectedChallanType] = useState({ value: 1, label: "Penalty" });
  const [TotalViolationFreq, setTotalViolationFreq] = useState();
  const [EmailPDFCheck, setEmailPDFCheck] = useState(false);
  const [ showDeleteButton, setShowDeleteButton] = useState(false);



  let newdata = [];
  let updatedViolationData;

  const [CompanyName, setCompanyName] = useState();
  const [CompanyAddress1, setNewCompanyAddress1] = useState();
  const [CompanyAddress2, setNewCompanyAddress2] = useState();
  const [CityName, setCityName] = useState();
  const [StateName, setStateName] = useState();
  const [NewChallanAmount, setNewChallanAmount] = useState();
  const [ChallanDetailsResponse, setChallanDetailsResponse] = useState();
  const [ ChallanType, setChallanType] = useState("Penalty");
  const [ChallanID, setChallanID] = useState();
  const [CompanyLogo, setCompanyLogo] = useState();
  const [SecondaryCompanyLogo, setSecondaryCompanyLogo] = useState();
  const[showEmailButton, setShowEmailButton] = useState(false);
  const[showSMSButton, setShowSMSButton] = useState(false);
  const [ DuplicateChallan, setDuplicateChallan]= useState(false);
var CompanyLocationName = '';
  //const ImgContextvalue = { violationImageIndex, setViolationImageIndex };
  

  const tog_small = () => {
    debugger;
    setmodal_small(!modal_small)
    document.body.classList.add("no_padding")
  }



  const handleChangeChallanType = event => {
    
    setSelectedChallanType(event);
    setChallanType(event.label);  
    console.log("Select Challan Type------>",SelectedChallanType);
    console.log("Challan Type--->", ChallanType);
    
  };

//   useEffect(() => {
   
  
//   if (props.ImgPath != null) {
//     debugger;
//     console.log(props.ImgPath)
//     fetch(apiEndpoint+"/GetViolationLogImages?strImagePath=" + props.ImgPath)
//       .then(res => res.json())
//       .then(
//         (result) => {
        
//           if (result != undefined || result != "") {
//             // console.log(result);
//             if (result.Message == "File not found!") {
//               console.log("No Image found!!");
//               setAlert(
//                 <ReactBSAlert
//                   warning
//                   //   style={bsAlertStyle}
//                   //   title="Good job!"
//                   onConfirm={() => setAlert(null)}
//                   onCancel={() => setAlert(null)}
//                   confirmBtnBsStyle="warning"
//                 >
//                   {result.Message}
//                 </ReactBSAlert>
//               )
//             }
//             else {
//               setImageData(result);
//             }

//           }
//           else {
//             console.log("No Image found!!");
//           }
//         },
//         // Note: it's important to handle errors here
//         // instead of a catch() block so that we don't swallow
//         // exceptions from actual bugs in components.
//         (error) => {
//           //console.log(error);
//           // /setError(error);
//         }
//       )
//     // }, [props.ImgPath])

//   }

// },[props.ImgPath]);



useEffect(() => {
  debugger;
   
  if(props.ViolationData.CampusID != null)
  {
    const intCampusID = props.ViolationData.CampusID;
    // UserValidated
    fetch(apiEndpoint+"/GetEmailSMSStatus",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "intCampusID": intCampusID,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      })
    .then(res => res.json())
    .then(
      (result) =>{
        debugger;
        if(result != undefined || result != "")
        {
            if(result.EnableEmail == 1)
            {
              setShowEmailButton(true);
            }
            else{
              setShowEmailButton(false);
            }
            if(result.EnableSMS == 1)
            {
              setShowSMSButton(true);
            }
            else{
              setShowSMSButton(false);
            }
        }
      }
    )
  }

},[props.ViolationData.CampusID]);

const ChallanTypeDropdown = [
  {
    value: 1,
    label: "Penalty"
  },
  {
    value: 2,
    label: "Warning"
  }
];

const GetChallanConfig = (violationData) =>{

 debugger;
  var intCampusID = violationData.CampusID;
    setTotalViolationFreq(violationData.TotalViolationFrequency);

    // UserValidated
  fetch(apiEndpoint+"/GetChallanConfigDetails",
  {
  method:"POST",
    headers: {
      'Content-Type': 'application/json',
      // 'Access-Control-Allow-Origin': '*',
    },
    body: JSON.stringify({
      "intCampusID": intCampusID,
      "strToken": sessionStorage.getItem("Clear_AuthUser")
    })
  })
  .then(res => res.json())
  .then((data) => {
    debugger;

    if (data.ChallanConfigDetails != null) {
      setCompanyName(data.ChallanConfigDetails.CompanyName);
      setNewCompanyAddress1(data.ChallanConfigDetails.AddressLine1);
      setNewCompanyAddress2(data.ChallanConfigDetails.AddressLine2);
      setCityName(data.ChallanConfigDetails.City);
      setStateName(data.ChallanConfigDetails.State);
      setNewChallanAmount(data.ChallanConfigDetails.ChallanAmount);
      setCompanyLogo(data.base64Image);
      setSecondaryCompanyLogo(data.secondBase64Image);
      setDuplicateChallan(data.ChallanConfigDetails.DuplicateChallan);



    }
    else {
      setModalOpen(false);
      setAlert(
        <ReactBSAlert
          warning
          //   style={bsAlertStyle}
          //   title="Good job!"
          onConfirm={event =>  window.location.href='/ChallanSettings'}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="warning"
          cancelBtnBsStyle="secondary"
          showCancel
          reverseButtons 
        >
          {"Challan Details Not Available"}
          <br /> 
          {"Can we Redirect you to Challan Settings Page ?"}
          
        </ReactBSAlert>
      )
      setCompanyName('');
      setNewCompanyAddress1('');
      setNewCompanyAddress2('');
      setCityName('');
      setStateName('');
      setNewChallanAmount('');
      setDuplicateChallan(false);

    }

  });

}


const DownloadPDF = (violationData, NewANPRVal, ChallanID) =>{
debugger;


let VehicleOwner = ''
if(violationData.VehicleOwnerName != null)
{
  VehicleOwner = violationData.VehicleOwnerName;
}
else{
  VehicleOwner = "NA";
}


let Department = ''
if(violationData.VehicleOwnerDept)
{
  Department = violationData.VehicleOwnerDept;
}
else{
  {
    Department = "NA";
  }
  
}
let EICName = ''
if(violationData.ManagerName)
{
  EICName = violationData.ManagerName;
}
else{
  EICName = "NA";

}


  let RegistrationNumber = '';
if(NewANPRVal != null)
{
RegistrationNumber = NewANPRVal;
}
else
{
RegistrationNumber =  violationData.RegistrationNumber;
}
debugger;
console.log(violationImageIndex)
console.log(imgData)

if(violationImageIndex == 0)
{
violationImage =  `data:image/png;base64,${imgData.ViolationImgBase64Img[0]}`;
console.log(violationImage)
}
else if(violationImageIndex == 1)
{
violationImage =  `data:image/png;base64,${imgData.ViolationImgBase64Img[1]}`; 
}
else if(violationImageIndex == 2)
{
violationImage =  `data:image/png;base64,${imgData.ViolationImgBase64Img[2]}`;
}

else if(violationImageIndex == 3)
{
violationImage =  `data:image/png;base64,${imgData.ViolationImgBase64Img[3]}`;
}


  console.log()
//var img = new Image();
// img.src = img2;
var img = '';
var secondaryImg = '';

debugger;

img = `data:image/png;base64,${CompanyLogo}`;

var CompanyAddress = "";

if(CompanyAddress1 != "")
{
   CompanyAddress = CompanyAddress1+","+CompanyAddress2;

}
else{
  CompanyAddress = CompanyAddress2;
}

var CityAddress = "";
if(CityName != "" && StateName == "") 
{
  CityAddress = CityName;
}
else if(StateName != "" && CityName == "")
{
  CityAddress = StateName;
}
else{
 CityAddress =  CityName+","+StateName;
}
var Speed = ''+violationData.VehicleSpeed+' Km/Hr';
var TotalViolationFrequency = ''+TotalViolationFreq;
var ChallanAmount = 'Rs.'+NewChallanAmount;
var UniqueChallanID = ''+ChallanID;




if(DuplicateChallan == true)
{
  var doc = new jsPDF('l', 'mm','a3');
doc.addFont('courier', 'Bold');
 doc.setFontSize(25);
 doc.text( "Vehicle Over Speeding Challan ",105,10,"center");
 doc.text( "Vehicle Over Speeding Challan ",305,10,"center");

 doc.setFontSize(20);
 doc.text(CompanyName, 100, 25, 'center');
 doc.text(CompanyName, 300, 25, 'center');
 doc.setFontSize(12); 
 doc.text(CompanyAddress, 100, 30, 'center');
 doc.text(CompanyAddress, 300, 30, 'center');

 doc.setFontSize(12); 
 doc.text(CityAddress, 100, 35, 'center');
 doc.text(CityAddress, 300, 35, 'center');

 doc.setFontSize(9);
 doc.text(17,50,"Dear Sir/Madam,");
 doc.text(217,50,"Dear Sir/Madam,");

 doc.text(17,55,"Your vehicle has violated prescribed speed limit inside " +  violationData.LocationName + " as mentioned below:")
 doc.text(217,55,"Your vehicle has violated prescribed speed limit inside " +  violationData.LocationName + " as mentioned below:")


 
  doc.rect(15, 60, 180, 110);
    doc.rect(215, 60, 180, 222);

  doc.setFontSize(12);
  doc.text(17, 67, "Challan ID");
  doc.text(217, 67, "Challan ID");

  doc.text(17, 77, "Violation Date Time");
  doc.text(217, 77, "Violation Date Time");

  doc.text(17, 87, "Violation Speed");
  doc.text(217, 87, "Violation Speed");

  doc.text(17, 97, "Vehicle Owner");
  doc.text(217, 97, "Vehicle Owner");

  doc.text(17, 107, "Regitration Number");
  doc.text(217, 107, "Regitration Number");

  doc.text(17, 117,"Challan Type");
  doc.text(217, 117,"Challan Type");

  doc.text(17, 127, "Challan Amount");
  doc.text(217, 127, "Challan Amount");

  doc.text(17,137,"Violation Frequency");
  doc.text(217,137,"Violation Frequency");

  doc.text(17,147,"Location Name");
  doc.text(217,147,"Location Name");

  doc.text(17,157,"Department");
  doc.text(217,157,"Department");

  doc.text(17,167,"EIC / HOD Name");
  doc.text(217,167,"EIC / HOD Name");



  doc.addImage(img, 'png', 150, 10, 50, 40)
  doc.addImage(img, 'png', 350, 10, 50, 40)


if(SecondaryCompanyLogo != "")
{
  secondaryImg = `data:image/png;base64,${SecondaryCompanyLogo}`;
  doc.addImage(secondaryImg,'png', 20,15,25,25);
  doc.addImage(secondaryImg,'png', 220,15,25,25);

}
 
                //  doc.rect(15, 63, 180, 75);
               doc.line(100,60,100,170);
               doc.line(300,60,300,170);

               doc.line(15, 70, 195, 70);
               doc.line(215, 70, 395, 70);

               doc.line(15, 80, 195, 80);
               doc.line(215, 80, 395, 80);

               doc.line(15, 90, 195, 90);
               doc.line(215, 90, 395, 90);

               doc.line(15, 100, 195, 100);
               doc.line(215, 100, 395, 100);

               doc.line(15, 110, 195, 110);
               doc.line(215, 110, 395, 110);

               doc.line(15, 120, 195, 120);
               doc.line(215, 120, 395, 120);

               doc.line(15, 130, 195, 130);
               doc.line(215, 130, 395, 130);

               doc.line(15, 140, 195, 140);
               doc.line(215, 140, 395, 140);

               doc.line(15,150, 195, 150 );
               doc.line(215,150, 395, 150 );

               doc.line(15,160, 195, 160 );
               doc.line(215,160, 395, 160 );

   
   doc.rect(15, 170, 180, 112);  
   doc.rect(215, 170, 180, 112);  

   doc.addImage(violationImage, 'png', 17, 172, 176, 108);
   doc.addImage(violationImage, 'png', 217, 172, 176, 108);  
  

   doc.text(UniqueChallanID, 102, 67);
   doc.text(UniqueChallanID, 302, 67);

   doc.text(violationData.IncidentTime,102, 77);
   doc.text(violationData.IncidentTime,302, 77);

   doc.text(RegistrationNumber,102, 107);
   doc.text(RegistrationNumber,302, 107);

   doc.text(Speed,102, 87);
   doc.text(Speed,302, 87);

   doc.text(VehicleOwner,102,97);
   doc.text(VehicleOwner,302,97);

   doc.text(ChallanType,102,117);
   doc.text(ChallanType,302,117);

   doc.text(TotalViolationFrequency, 102,137)
   doc.text(TotalViolationFrequency, 302,137)

   doc.text(violationData.LocationName, 102,147);
   doc.text(violationData.LocationName, 302,147);

   doc.text(Department, 102,157);
   doc.text(Department, 302,157);

   doc.text(EICName,102,167);
   doc.text(EICName,302,167);

   if(ChallanType == "Warning")
   {
    doc.text("-", 102, 117)
    doc.text("-", 302, 117)


   }
   else{
    doc.text(ChallanAmount, 102, 127);
    doc.text(ChallanAmount, 302, 127);


   }
              
  //  const pdfData = doc.output();
  //  const pdfBlob = new Blob([pdfData], { type: 'application/pdf' });
  //  savePDFToServer(pdfBlob);
  if(EmailPDFCheck != true)
  {
    doc.save('Challan'+RegistrationNumber+'.pdf')
    setAlert(
      <ReactBSAlert
        success
        //   style={bsAlertStyle}
        title="Challan Downloaded!"
        onConfirm={() => setAlert(null)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="info"
      >
      </ReactBSAlert>
    )
  }

  console.log("No need of duplicte challan");
}
else{



var doc = new jsPDF('p', 'mm','a4');
doc.addFont('courier', 'Bold');
 doc.setFontSize(25);
 doc.text( "Vehicle Over Speeding Challan ",105,10,"center");
 doc.setFontSize(20);
 doc.text(CompanyName, 100, 25, 'center');
 doc.setFontSize(12); 
 doc.text(CompanyAddress, 100, 30, 'center');
 doc.setFontSize(12); 
 doc.text(CityAddress, 100, 35, 'center');

 doc.setFontSize(9);
 doc.text(17,50,"Dear Sir/Madam,");
 doc.text(17,55,"Your vehicle has violated prescribed speed limit inside " +  violationData.LocationName + " as mentioned below:")


 
  doc.rect(15, 60, 180, 110);
  doc.setFontSize(12);
  doc.text(17, 67, "Challan ID");
  doc.text(17, 77, "Violation Date Time");
  doc.text(17, 87, "Violation Speed");
  doc.text(17, 97, "Vehicle Owner");
  doc.text(17, 107, "Regitration Number");
  doc.text(17, 117,"Challan Type");
  doc.text(17, 127, "Challan Amount");
  doc.text(17,137,"Violation Frequency");
  doc.text(17,147,"Location Name");
  doc.text(17,157,"Department");
  doc.text(17,167,"EIC / HOD Name");


  doc.addImage(img, 'png', 150, 10, 50, 40)

if(SecondaryCompanyLogo != "")
{
  secondaryImg = `data:image/png;base64,${SecondaryCompanyLogo}`;
  doc.addImage(secondaryImg,'png', 20,15,25,25);
}
 
                //  doc.rect(15, 63, 180, 75);
               doc.line(100,60,100,170)
               doc.line(15, 70, 195, 70);
               doc.line(15, 80, 195, 80);
               doc.line(15, 90, 195, 90);
               doc.line(15, 100, 195, 100);
               doc.line(15, 110, 195, 110);
               doc.line(15, 120, 195, 120);
               doc.line(15, 130, 195, 130);
               doc.line(15, 140, 195, 140);
               doc.line(15,150, 195, 150 );
               doc.line(15,160, 195, 160 );
   
   doc.rect(15, 170, 180, 112);  
   doc.addImage(violationImage, 'png', 17, 172, 176, 108)  

   doc.text(UniqueChallanID, 102, 67)
   doc.text(violationData.IncidentTime,102, 77);
   doc.text(RegistrationNumber,102, 107);
   doc.text(Speed,102, 87);
   doc.text(VehicleOwner,102,97);
   doc.text(ChallanType,102,117);
   doc.text(TotalViolationFrequency, 102,137)
   doc.text(violationData.LocationName, 102,147);
   doc.text(Department, 102,157);
   doc.text(EICName,102,167);
   if(ChallanType == "Warning")
   {
    doc.text("-", 102, 117)

   }
   else{
    doc.text(ChallanAmount, 102, 127);

   }
              
  //  const pdfData = doc.output();
  //  const pdfBlob = new Blob([pdfData], { type: 'application/pdf' });
  //  savePDFToServer(pdfBlob);
  if(EmailPDFCheck != true)
  {
    doc.save('Challan'+RegistrationNumber+'.pdf')
    setAlert(
      <ReactBSAlert
        success
        //   style={bsAlertStyle}
        title="Challan Downloaded!"
        onConfirm={() => setAlert(null)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="info"
      >
      </ReactBSAlert>
    )
  }
}

  debugger;
if(EmailPDFCheck == true && violationData.VehicleOwnerEmailAddress != null)
{
  const pdfData = doc.output('datauristring');
  EmailChallanToVehicleOwner(pdfData, violationData)
}
}

    const GetViolationImage = (RecordID) => {
        if (RecordID != null) {
    debugger;
    // UserValidated
    fetch(apiEndpoint+"/GetViolationLogImages",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            "RecordID": RecordID,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      })
      .then(res => res.json())
      .then(
        (result) => {
        
          if (result != undefined || result != "") {
            // console.log(result);
            if (result.Message == "File not found!") {
              console.log("No Image found!!");
              setAlert(
                <ReactBSAlert
                  warning
                  //   style={bsAlertStyle}
                  //   title="Good job!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="warning"
                >
                  {result.Message}
                </ReactBSAlert>
              )
            }
            else {
              setImageData(result);
            }

          }
          else {
            console.log("No Image found!!");
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          //console.log(error);
          // /setError(error);
        }
      )
    // }, [props.ImgPath])

  }

};


const DownloadChallan = (violationData, NewANPRVal) => 
{
  debugger;
  // UserValidated
  fetch(apiEndpoint+"/SaveChallanGenerationLogs",
  {
    mode: "cors",
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      //'Access-Control-Allow-Origin': '*',
    },
    body: JSON.stringify({
              "RecordID": violationData.RecordID,
              "CampusID": violationData.CampusID,
              "LocationID": violationData.LocationID,
              "IncidentTime": violationData.IncidentTime,
              "ChallanAmount": NewChallanAmount,
              "ChallanType": ChallanType,
              "VehicleSpeed": violationData.VehicleSpeed,
              "RegistrationNumber": NewANPRVal,
              "strToken": sessionStorage.getItem("Clear_AuthUser")
            }) 
  })
  .then(res => res.json())
  .then((data) => {
    debugger;

    if (data.ChallanID != null) {
      debugger;
        DownloadPDF(violationData,NewANPRVal,data.ChallanID);

    }
    else {
      
    }

  });
}

const  EmailChallanToVehicleOwner = (pdfData, violationData) =>{
  debugger;
  // const pdf = new jsPDF();
  // pdf.text('Hello, World!', 10, 10);
  // const pdfData = pdf.output('datauristring');

  // UserValidated
  fetch(apiEndpoint+"/GetChallanPDF",
  {
    mode: "cors",
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      //'Access-Control-Allow-Origin': '*',
    },
    body: JSON.stringify({ pdfData: pdfData,
     VehicleOwnerName: violationData.VehicleOwnerName,
    VehicleOwnerEmail: violationData.VehicleOwnerEmailAddress,
    IncidentTime: violationData.IncidentTime,
    CampusName: violationData.CampusName,
    LocationName: violationData.LocationName,
    RegistrationNumber: violationData.RegistrationNumber,
    CampusID: violationData.CampusID,
    strToken: sessionStorage.getItem("Clear_AuthUser")
    }) 
            
  })
  .then(res => res.json())
  .then((data) => {
    debugger;
    console.log(data);
    setModalOpen(false);
    if(data.Message == "success")
    setAlert(
      <ReactBSAlert
        success
        //   style={bsAlertStyle}
        title="Email has been sent!"
        onConfirm={() => setAlert(null)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="info"
      >
      </ReactBSAlert>
    )
    else{
      setAlert(
        <ReactBSAlert
          warning
          //   style={bsAlertStyle}
          title="Vehicle Owner Email Address in Not Available"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="warning"
        >
        </ReactBSAlert>
      )
    }

  });

}

const toggle = () => {

    setModalIsOpen(!modalIsOpen)
   
  }

const SaveViolation = (violationData, NewANPRVal) => {
    debugger;
    
    setTotalViolationFreq(violationData.TotalViolationFrequency);
    // UserValidated
    fetch(apiEndpoint+"/UpdateViolationANPRLog",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "RecordID": violationData.RecordID,
          //"IncidentTime": violationData.IncidentTime,
          "RegistrationNumber": NewANPRVal,
          "Token": sessionStorage.getItem("Clear_AuthUser")
        })
      })

      // const updatedData = await response.json();
      // return updatedData;
      .then(res => res.json())
      .then(
        (result) => {
          if (result != undefined) {
            //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
            console.log(result);
            if (result.Violations != undefined) {
              setAlert(
                <ReactBSAlert
                  success
                  //   style={bsAlertStyle}
                  title="Data Saved Successfully!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="info"
                >
                </ReactBSAlert>
               
              )
              debugger;
              var recdID = JSON.parse(result.Violations).RecordID;
              newdata = violations.slice();
            // newdata.find(someobject => someobject.RecordID == recdID).ViolationData = JSON.parse(result.Violations)  ;
        newdata.find((someobject) => {
                        if(someobject.RecordID === recdID){
                        someobject.RegistrationNumber = NewANPRVal;
                        someobject.VehicleOwnerName = JSON.parse(result.Violations).VehicleOwnerName;
                        someobject.VehicleOwnerDept = JSON.parse(result.Violations).VehicleOwnerDept;
                        someobject.ManagerName = JSON.parse(result.Violations).ManagerName;
                        someobject.VehicleOwnerContact = JSON.parse(result.Violations).VehicleOwnerContact;
                        someobject.VehicleOwnerEmailAddress = JSON.parse(result.Violations).VehicleOwnerEmailAddress;
                        someobject.EditDeleteStatus = JSON.parse(result.Violations).EditDeleteStatus;

                                                                                          


              }} );

             // CompanyLocationName = newdata.find(log => log.RecordID == recdID).LocationName;
              setTotalViolationFreq(JSON.parse(result.Violations).TotalViolationFrequency);
              setViolations(newdata);
              console.log("Save Data--->", newdata);


              setshowGenerateChallanButton(true);
            }
            else {
              setAlert(
                <ReactBSAlert
                  warning
                  //   style={bsAlertStyle}
                  title="Something went wrong!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="warning"
                >
                  {result.Message}
                </ReactBSAlert>
              )
            }
          }
          else {
            setAlert(
              <ReactBSAlert
                warning
                //   style={bsAlertStyle}
                title="Something went wrong!"
                onConfirm={() => setAlert(null)}
                onCancel={() => setAlert(null)}
                confirmBtnBsStyle="warning"
              >
                {result.Message}
              </ReactBSAlert>
            )
          }
        }
      )
  }

  const handleEmailPDFCheck = () => {
    debugger;
    setEmailPDFCheck(true);

  };

  const handleEmailAction = (violationData, NewANPRVal) => {
    debugger;
    const emailPromise = new Promise((resolve, reject) => {
      debugger;
    
      resolve();
    });
  
    emailPromise.then(() => {
      handleEmailPDFCheck();
    }).catch((error) => {
      // Handle error if any Promise in the chain encounters an issue
    });
  };

  const SendEmailToVehicleOwner = (violationData, NewANPRVal) =>{
    debugger;

    if(violationData.VehicleOwnerEmailAddress != null)
    {
      // UserValidated
      fetch(apiEndpoint+"/SendEmailToRegisteredVehicleOwner",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "RecordID": violationData.RecordID,
          //"IncidentTime": violationData.IncidentTime,
          "RegistrationNumber": NewANPRVal,
          "LocationName": violationData.LocationName,
          "CampusName": violationData.CampusName,
          "CampusID": violationData.CampusID,
          "LocationID": violationData.LocationID,
          "VehicleOwnerName": violationData.VehicleOwnerName,
          "VehicleOwnerContact": violationData.VehicleOwnerContact,
          "VehicleOwnerEmailAddress": violationData.VehicleOwnerEmailAddress,
          "ManagerName": violationData.ManagerName,
          "VehicleOwnerDept": violationData.VehicleOwnerDept,
          "IncidentDateTime": violationData.IncidentTime,
          "VehicleSpeed": violationData.VehicleSpeed,
          "DailyViolationFrequency": violationData.TotalViolationFrequency,
  
          "Token": sessionStorage.getItem("Clear_AuthUser")
        })
      })
        .then(res => res.json())
        .then((data) => {
         debugger;
      
   
      if(data.responseType == "success")
      setAlert(
        <ReactBSAlert
          success
          //   style={bsAlertStyle}
          title="Email sent Successfully !"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="info"
        >
        </ReactBSAlert>
        
        
      )
      else{
        setAlert(
          <ReactBSAlert
            warning
            //   style={bsAlertStyle}
            title="Vehicle Owner Email Address in Not Available"
            onConfirm={() => setAlert(null)}
            onCancel={() => setAlert(null)}
            confirmBtnBsStyle="warning"
          >
          </ReactBSAlert>
        )
      }
  
  
  })
    }
    else{
      setAlert(
        <ReactBSAlert
          warning
          //   style={bsAlertStyle}
          title="Vehicle Owner Email Address is Not Available"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="warning"
        >
        </ReactBSAlert>
      )
    }
    


  };

  const SendSMSToVehicleOwner = (violationData, NewANPRVal) =>{
    debugger;

    if(violationData.VehicleOwnerContact != null)
    {
      // UserValidated
      fetch(apiEndpoint+"/SendSMSToRegisteredVehicleOwnerContact",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "RecordID": violationData.RecordID,
          //"IncidentTime": violationData.IncidentTime,
          "RegistrationNumber": NewANPRVal,
          "LocationName": violationData.LocationName,
          "VehicleOwnerName": violationData.VehicleOwnerName,
          "VehicleOwnerContact": violationData.VehicleOwnerContact,
          "VehicleOwnerEmailAddress": violationData.VehicleOwnerEmailAddress,
          "IncidentDateTime": violationData.IncidentTime,
          "VehicleSpeed": violationData.VehicleSpeed,  
          "Token": sessionStorage.getItem("Clear_AuthUser")
        })
      })
        .then(res => res.json())
        .then((data) => {
         debugger;
      
   
      if(data.responseType == "success")
      setAlert(
        <ReactBSAlert
          success
          //   style={bsAlertStyle}
          title="Text Message sent Successfully !"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="info"
        >
        </ReactBSAlert>
        
        
      )
      else{
        setAlert(
          <ReactBSAlert
            warning
            //   style={bsAlertStyle}
            title="Vehicle Owner Contact is Not Available"
            onConfirm={() => setAlert(null)}
            onCancel={() => setAlert(null)}
            confirmBtnBsStyle="warning"
          >
          </ReactBSAlert>
        )
      }
  
  
  })
    }
    else{
      setAlert(
        <ReactBSAlert
          warning
          //   style={bsAlertStyle}
          title="Vehicle Owner  Contact is Not Available"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="warning"
        >
        </ReactBSAlert>
      )
    }
    


  };

  useEffect(() => {
    if (EmailPDFCheck) {
      debugger;
      DownloadChallan(props.ViolationData, ANPRVal);
      setEmailPDFCheck(false);
       
    }
  }, [EmailPDFCheck]);
  

  
  
  
  

 
  const DeleteViolation = (violationData) => {
    // UserValidated
    fetch(apiEndpoint+"/DeleteViolationANPRLog",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "RecordID": violationData.RecordID,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      })
      .then(res => res.json())
      .then(
        (result) => {
          if (result != undefined) {
            //console.log(result);
            if (result.Violations != undefined) {
              setAlert(
                <ReactBSAlert
                  success
                  //   style={bsAlertStyle}
                  title="Record Deleted Successfully!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="info"
                >
                </ReactBSAlert>
              )

              var recdID = JSON.parse(result.Violations).RecordID;
              let newdata = violations.slice();
              var elindex=newdata.findIndex(someobject => someobject.RecordID == recdID);
              //delete newdata[elindex];
              newdata.splice(elindex, 1);
              setViolations(newdata);
            }
            else {
              setAlert(
                <ReactBSAlert
                  warning
                  //   style={bsAlertStyle}
                  title="Something went wrong!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="warning"
                >
                  {result.Message}
                </ReactBSAlert>
              )
            }
          }
          else {
            setAlert(
              <ReactBSAlert
                warning
                //   style={bsAlertStyle}
                title="Something went wrong!"
                onConfirm={() => setAlert(null)}
                onCancel={() => setAlert(null)}
                confirmBtnBsStyle="warning"
              >
                {result.Message}
              </ReactBSAlert>
            )
          }
        }
      )
  }

  return (
    <>
      <Link
        onClick={() => {
          const decodedToken = jwt.decode(sessionStorage.getItem("Clear_AuthUser"));
          var UserPermissions=JSON.parse(decodedToken.userRolePermissions);
          // var UserPermissions=JSON.parse(sessionStorage.getItem("UserRolePermissions"));
          GetViolationImage(props.ViolationData.RecordID);
          setShowDeleteButton(UserPermissions.DeleteViolations);
          
          setANPR(props.ViolationData.RegistrationNumber);
         
          if(props.ViolationData.EditDeleteStatus == "01")
          {
            setshowGenerateChallanButton(true);

          }
          else{
            setshowGenerateChallanButton(false);
          }
          toggle();
          
        }}
        ><i className=" mdi mdi-border-color mdi-24px"></i></Link>
      
      {modalIsOpen==true && alertmsg}
      {props.ViolationData != undefined && imgData!=undefined &&
        <Modal isOpen={modalIsOpen} style={{ maxWidth: "60%" }}>

          <ModalHeader toggle={toggle} tag="h4">
          </ModalHeader>
          <ModalBody>
            <AvForm className="needs-validation">
              {/* {props.ViolationData.RegistrationNumber} */}
              <Row>
                {/* <ActiveImageContext.Provider value={ImgContextvalue} > */}
                <Slidewithindicator ImagePath={imgData} ImageIndex={setViolationImageIndex}/>
                {/* </ActiveImageContext.Provider> */}
               
              </Row>

              <Row>

                <Col md={12}>
                  <label for="RegistrationNumberid" className="mt-3">Registration Number</label>
                 <AvField
                    name="RegistrationNumberid"
                    placeholder="Registration Number"
                    type="text"
                    className="form-control"
                    value={props.ViolationData.RegistrationNumber}
                    id="registrationNumberid"
                    onChange={(event) => setANPR(event.target.value)}
                  />
                </Col>
                <Col md={12}>
                  {showDeleteButton &&
                    <button className=" mt-3  mdi mdi-delete  btn btn-primary mdi-18px"
                    id="DeleteBtnID"
                    onClick={() => {
                      DeleteViolation(props.ViolationData);
                      toggle();
                    }}></button>

                  }
                
               
                  <button className=" mt-3 mx-2 mdi mdi-content-save btn btn-primary mdi-18px"
                  id="SaveBtnID"
                    onClick={() => {
                      SaveViolation(props.ViolationData, ANPRVal)
                    //  console.log(props.ViolationData);
                    }} ></button>

                { showGenerateChallanButton &&
                <button className=" mt-3 mdi mdi-format-float-left btn btn-primary mdi-18px"
                    to="#" role="Button" id="ChallanBtn"
                    onClick={() => {
                      setEmailPDFCheck(false);
                      GetChallanConfig(props.ViolationData);
                      tog_small();                    
                      setModalOpen(true);
                      
                     
                    }} ></button>
                  }

                    { showGenerateChallanButton &&  showEmailButton &&
                      <button className=" mt-3 mx-2 mdi mdi-email btn btn-primary mdi-18px"
                          to="#" role="Button" id="EmailBtnID"
                          onClick={() => {
                            SendEmailToVehicleOwner(props.ViolationData,ANPRVal);
                           
                            
                           
                          }} ></button>


                }

                { showGenerateChallanButton && showSMSButton &&
                      <button className=" mt-3  mdi mdi-message-text btn btn-primary mdi-18px"
                          to="#" role="Button" id="TextMsgBtnID"
                          onClick={() => {
                            SendSMSToVehicleOwner(props.ViolationData, ANPRVal);
                            
                           
                          }} ></button>

                          
                }
               {showDeleteButton &&  <UncontrolledTooltip placement="top" target="DeleteBtnID">
                                                           Delete
                                                        </UncontrolledTooltip>
}
                                              {showSMSButton && showGenerateChallanButton &&
                                                 <UncontrolledTooltip placement="top" target="TextMsgBtnID">
                                                          Text Message
                                                        </UncontrolledTooltip> 
                                              }  

<UncontrolledTooltip placement="top" target="SaveBtnID">
                                                          Save
                                                        </UncontrolledTooltip>
{ showGenerateChallanButton && 
    <UncontrolledTooltip placement="top" target="ChallanBtn">
    Challan
  </UncontrolledTooltip>}
{ showGenerateChallanButton && showEmailButton &&
 <UncontrolledTooltip placement="top" target="EmailBtnID">
 E-Mail
</UncontrolledTooltip>}

                                                      
                                                    
                                                       
                                                       
                                                      
                </Col>
              </Row>
            </AvForm>
          </ModalBody>

        </Modal>
       
      }
         {modalOpen ?
      <Modal 
        isOpen={modal_small}
        style={{ maxWidth: "30%" }}

        // toggle={() => {
        //   tog_small()

        // }}

      >
       <ModalHeader toggle={ () => {
          tog_small()

        }} tag="h1">
          </ModalHeader>
        <ModalBody>

          <Row className="mb-3">
            <label
              htmlFor="example-email-input"
              className="col-md-4 col-form-label"
            >
             Challan Type
            </label>
            <div className="col-sm-6 ">
            <Select value={SelectedChallanType} options={ChallanTypeDropdown} onChange={handleChangeChallanType}></Select>
            </div>
           
           
            
          </Row>
          <Row className="mb-3">
          <label
              htmlFor="example-email-input"
              className="col-sm-4 col-form-label"
            >
             Violation Frequency
            </label>
            <div className="col-sm-6 ">
            <input
               className="form-control"
               type="text"
               defaultValue={TotalViolationFreq}
               disabled
             />
            </div>
          </Row>
 
          <Row className="mb-3">
            <div class="col-sm-4">

            </div>
          <div class="col-sm-6">
          <button type="submit" className=" mdi mdi-download btn btn-primary mdi-12px"   onClick={() => {DownloadChallan(props.ViolationData, ANPRVal)}}> Download</button> 
          {/* <button type="submit" className=" mdi mdi-email btn btn-primary mdi-12px" style={{margin:"16px"}}  onClick={() => {handleEmailAction(props.ViolationData, ANPRVal)}}> E-Mail</button>  */}

          </div>
          
          
          </Row>
          <Row>
            
          </Row>
         
          
        
        

        
        </ModalBody>
       <ModalFooter>
       
       </ModalFooter>
      </Modal>
      : ""}
    </>
  
  )

}


export default EditViolationModalComponent;